import PropTypes from "prop-types";
import React from "react";
import CompetingHoldsCard from "./CompetingHoldsCard";
import DateFactorsCard from "./DateFactorsCard";
import EstRevenueCard from "./EstRevenueCard";

const SelectedHoldDetail = ({ hold, weatherPending, onConfirm }) => {
  if (!hold) return null;
  return (
    <div className="hd-detail">
      <div className="hd-detail-head">
        <h2 className="d2-card-title">{`${hold.day}, ${hold.date}`}</h2>
        <span className="hd-pos">{hold.id}</span>
        <span className="hd-detail-hint">Selected hold — click another date above to compare.</span>
      </div>
      <div className="d2-grid-3">
        <CompetingHoldsCard hold={hold} />
        <DateFactorsCard hold={hold} weatherPending={weatherPending} />
        <EstRevenueCard hold={hold} onConfirm={onConfirm} />
      </div>
    </div>
  );
};

SelectedHoldDetail.propTypes = {
  hold: PropTypes.object,
  weatherPending: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
};

export default SelectedHoldDetail;
